//Function used to open up the contact form
export const openContactForm = (): void => {
  //Animating the contactForm up
  const contactForm = document.getElementById("contactForm");
  if (contactForm) contactForm.classList.remove("notActive");

  // Disable body scroll
  document.body.style.overflow = "hidden";

  //Removing the background information
  setTimeout(() => {
    const header = document.getElementById("header");
    const mainBody = document.getElementById("mainBody");
    if (header) header.classList.add("notActive");
    if (mainBody) mainBody.classList.add("notActive");
  }, 600);
};

//Function to close the contact form
export const closeContactForm = (): void => {
  //Animating the contactForm down
  const contactForm = document.getElementById("contactForm");
  const header = document.getElementById("header");
  const mainBody = document.getElementById("mainBody");

  if (contactForm) contactForm.classList.add("removeContactForm");
  if (header) header.classList.remove("notActive");
  if (mainBody) mainBody.classList.remove("notActive");

  // Re-enable body scroll
  document.body.style.overflow = "auto";

  //Completely removing the contact form
  setTimeout(() => {
    //Appending / Removing the classes needed
    if (contactForm) {
      contactForm.classList.add("notActive");
      contactForm.classList.remove("removeContactForm");
    }
  }, 600);
};
